import { render } from "./ImageZoom.vue?vue&type=template&id=8138617c&scoped=true"
import script from "./ImageZoom.vue?vue&type=script&lang=ts"
export * from "./ImageZoom.vue?vue&type=script&lang=ts"

import "./ImageZoom.vue?vue&type=style&index=0&id=8138617c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-8138617c"

export default script